import React from 'react';
import {Box, Typography} from "@mui/material";
import useSystemTheme from "../../../hooks/useSystemTheme";
import KeyIcon from "../icons/KeyIcon";

const KeyTag = ({keytag}) => {
    const {isDarkMode} = useSystemTheme();

    return (
        <Box
            display="flex"
            alignItems="center"
            gap="8px"
        >
            <Box
                display="flex"
                alignItems="center"
                alignContent="center"
                width="24px"
                height="24px"
                bgcolor={isDarkMode ? "#001489" : "transparent"}
                borderRadius="50%"
                padding="2px"
            >
                <KeyIcon strokeColor={isDarkMode ? "#FFFFFF" : "#001489"}/>
            </Box>
            <Typography
                color={isDarkMode ? "#FFFFFF" : "#000000"}
                fontWeight={400}
                fontSize={16}
                lineHeight={1}
                fontFamily="'Outfit', sans-serif"
            > {`Key Tag: ${keytag}`}
            </Typography>
        </Box>
    );
}

export default KeyTag;